import { render } from "./AdminReportsView.vue?vue&type=template&id=03743e7b&ts=true"
import script from "./AdminReportsView.vue?vue&type=script&lang=ts"
export * from "./AdminReportsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__